import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { DateUtils } from "../../util/DateUtils";
import { RdbmsSchemaBuilder } from "../../schema-builder/RdbmsSchemaBuilder";
import { OrmUtils } from "../../util/OrmUtils";
import { ApplyValueTransformers } from "../../util/ApplyValueTransformers";
import { DriverUtils } from "../DriverUtils";
import { TypeORMError } from "../../error";
import { InstanceChecker } from "../../util/InstanceChecker";
/**
 * Organizes communication with sqlite DBMS.
 */
export var AbstractSqliteDriver = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function AbstractSqliteDriver(connection) {
    _classCallCheck(this, AbstractSqliteDriver);
    /**
     * Indicates if replication is enabled.
     */
    this.isReplicated = false;
    /**
     * Indicates if tree tables are supported by this driver.
     */
    this.treeSupport = true;
    /**
     * Represent transaction support by this driver
     */
    this.transactionSupport = "nested";
    /**
     * Gets list of supported column data types by a driver.
     *
     * @see https://www.tutorialspoint.com/sqlite/sqlite_data_types.htm
     * @see https://sqlite.org/datatype3.html
     */
    this.supportedDataTypes = ["int", "integer", "tinyint", "smallint", "mediumint", "bigint", "unsigned big int", "int2", "int8", "integer", "character", "varchar", "varying character", "nchar", "native character", "nvarchar", "text", "clob", "text", "blob", "real", "double", "double precision", "float", "real", "numeric", "decimal", "boolean", "date", "time", "datetime"];
    /**
     * Returns type of upsert supported by driver if any
     */
    this.supportedUpsertType = "on-conflict-do-update";
    /**
     * Gets list of column data types that support length by a driver.
     */
    this.withLengthColumnTypes = ["character", "varchar", "varying character", "nchar", "native character", "nvarchar", "text", "blob", "clob"];
    /**
     * Gets list of spatial column data types.
     */
    this.spatialTypes = [];
    /**
     * Gets list of column data types that support precision by a driver.
     */
    this.withPrecisionColumnTypes = ["real", "double", "double precision", "float", "real", "numeric", "decimal", "date", "time", "datetime"];
    /**
     * Gets list of column data types that support scale by a driver.
     */
    this.withScaleColumnTypes = ["real", "double", "double precision", "float", "real", "numeric", "decimal"];
    /**
     * Orm has special columns and we need to know what database column types should be for those types.
     * Column types are driver dependant.
     */
    this.mappedDataTypes = {
      createDate: "datetime",
      createDateDefault: "datetime('now')",
      updateDate: "datetime",
      updateDateDefault: "datetime('now')",
      deleteDate: "datetime",
      deleteDateNullable: true,
      version: "integer",
      treeLevel: "integer",
      migrationId: "integer",
      migrationName: "varchar",
      migrationTimestamp: "bigint",
      cacheId: "int",
      cacheIdentifier: "varchar",
      cacheTime: "bigint",
      cacheDuration: "int",
      cacheQuery: "text",
      cacheResult: "text",
      metadataType: "varchar",
      metadataDatabase: "varchar",
      metadataSchema: "varchar",
      metadataTable: "varchar",
      metadataName: "varchar",
      metadataValue: "text"
    };
    this.cteCapabilities = {
      enabled: true,
      requiresRecursiveHint: true
    };
    // -------------------------------------------------------------------------
    // Protected Properties
    // -------------------------------------------------------------------------
    /**
     * Any attached databases (excepting default 'main')
     */
    this.attachedDatabases = {};
    this.connection = connection;
    this.options = connection.options;
    this.database = DriverUtils.buildDriverOptions(this.options).database;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Performs connection to the database.
   */
  _createClass(AbstractSqliteDriver, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.createDatabaseConnection();
            case 2:
              this.databaseConnection = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
    /**
     * Makes any action after connection (e.g. create extensions in Postgres driver).
     */
  }, {
    key: "afterConnect",
    value: function afterConnect() {
      return Promise.resolve();
    }
    /**
     * Closes connection with database.
     */
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (ok, fail) {
                _this.queryRunner = undefined;
                _this.databaseConnection.close(function (err) {
                  return err ? fail(err) : ok();
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function disconnect() {
        return _disconnect.apply(this, arguments);
      }
      return disconnect;
    }()
  }, {
    key: "hasAttachedDatabases",
    value: function hasAttachedDatabases() {
      return !!Object.keys(this.attachedDatabases).length;
    }
  }, {
    key: "getAttachedDatabaseHandleByRelativePath",
    value: function getAttachedDatabaseHandleByRelativePath(path) {
      var _a, _b;
      return (_b = (_a = this.attachedDatabases) === null || _a === void 0 ? void 0 : _a[path]) === null || _b === void 0 ? void 0 : _b.attachHandle;
    }
  }, {
    key: "getAttachedDatabasePathRelativeByHandle",
    value: function getAttachedDatabasePathRelativeByHandle(handle) {
      var _a;
      return (_a = Object.values(this.attachedDatabases).find(function (_ref) {
        var attachHandle = _ref.attachHandle;
        return handle === attachHandle;
      })) === null || _a === void 0 ? void 0 : _a.attachFilepathRelative;
    }
    /**
     * Creates a schema builder used to build and sync a schema.
     */
  }, {
    key: "createSchemaBuilder",
    value: function createSchemaBuilder() {
      return new RdbmsSchemaBuilder(this.connection);
    }
    /**
     * Prepares given value to a value to be persisted, based on its column type and metadata.
     */
  }, {
    key: "preparePersistentValue",
    value: function preparePersistentValue(value, columnMetadata) {
      if (columnMetadata.transformer) value = ApplyValueTransformers.transformTo(columnMetadata.transformer, value);
      if (value === null || value === undefined) return value;
      if (columnMetadata.type === Boolean || columnMetadata.type === "boolean") {
        return value === true ? 1 : 0;
      } else if (columnMetadata.type === "date") {
        return DateUtils.mixedDateToDateString(value);
      } else if (columnMetadata.type === "time") {
        return DateUtils.mixedDateToTimeString(value);
      } else if (columnMetadata.type === "datetime" || columnMetadata.type === Date) {
        // to string conversation needs because SQLite stores date as integer number, when date came as Object
        // TODO: think about `toUTC` conversion
        return DateUtils.mixedDateToUtcDatetimeString(value);
      } else if (columnMetadata.type === "simple-array") {
        return DateUtils.simpleArrayToString(value);
      } else if (columnMetadata.type === "simple-json") {
        return DateUtils.simpleJsonToString(value);
      } else if (columnMetadata.type === "simple-enum") {
        return DateUtils.simpleEnumToString(value);
      }
      return value;
    }
    /**
     * Prepares given value to a value to be hydrated, based on its column type or metadata.
     */
  }, {
    key: "prepareHydratedValue",
    value: function prepareHydratedValue(value, columnMetadata) {
      if (value === null || value === undefined) return columnMetadata.transformer ? ApplyValueTransformers.transformFrom(columnMetadata.transformer, value) : value;
      if (columnMetadata.type === Boolean || columnMetadata.type === "boolean") {
        value = value ? true : false;
      } else if (columnMetadata.type === "datetime" || columnMetadata.type === Date) {
        /**
         * Fix date conversion issue
         *
         * If the format of the date string is "2018-03-14 02:33:33.906", Safari (and iOS WKWebView) will convert it to an invalid date object.
         * We need to modify the date string to "2018-03-14T02:33:33.906Z" and Safari will convert it correctly.
         *
         * ISO 8601
         * https://www.w3.org/TR/NOTE-datetime
         */
        if (value && typeof value === "string") {
          // There are various valid time string formats a sqlite time string might have:
          // https://www.sqlite.org/lang_datefunc.html
          // There are two separate fixes we may need to do:
          //   1) Add 'T' separator if space is used instead
          //   2) Add 'Z' UTC suffix if no timezone or offset specified
          if (/^\d\d\d\d-\d\d-\d\d \d\d:\d\d/.test(value)) {
            value = value.replace(" ", "T");
          }
          if (/^\d\d\d\d-\d\d-\d\dT\d\d:\d\d(:\d\d(\.\d\d\d)?)?$/.test(value)) {
            value += "Z";
          }
        }
        value = DateUtils.normalizeHydratedDate(value);
      } else if (columnMetadata.type === "date") {
        value = DateUtils.mixedDateToDateString(value);
      } else if (columnMetadata.type === "time") {
        value = DateUtils.mixedTimeToString(value);
      } else if (columnMetadata.type === "simple-array") {
        value = DateUtils.stringToSimpleArray(value);
      } else if (columnMetadata.type === "simple-json") {
        value = DateUtils.stringToSimpleJson(value);
      } else if (columnMetadata.type === "simple-enum") {
        value = DateUtils.stringToSimpleEnum(value, columnMetadata);
      } else if (columnMetadata.type === Number) {
        // convert to number if number
        value = !isNaN(+value) ? parseInt(value) : value;
      }
      if (columnMetadata.transformer) value = ApplyValueTransformers.transformFrom(columnMetadata.transformer, value);
      return value;
    }
    /**
     * Replaces parameters in the given sql with special escaping character
     * and an array of parameter names to be passed to a query.
     */
  }, {
    key: "escapeQueryWithParameters",
    value: function escapeQueryWithParameters(sql, parameters, nativeParameters) {
      var _this2 = this;
      var escapedParameters = Object.keys(nativeParameters).map(function (key) {
        // Mapping boolean values to their numeric representation
        if (typeof nativeParameters[key] === "boolean") {
          return nativeParameters[key] === true ? 1 : 0;
        }
        if (nativeParameters[key] instanceof Date) {
          return DateUtils.mixedDateToUtcDatetimeString(nativeParameters[key]);
        }
        return nativeParameters[key];
      });
      if (!parameters || !Object.keys(parameters).length) return [sql, escapedParameters];
      sql = sql.replace(/:(\.\.\.)?([A-Za-z0-9_.]+)/g, function (full, isArray, key) {
        if (!parameters.hasOwnProperty(key)) {
          return full;
        }
        var value = parameters[key];
        if (isArray) {
          return value.map(function (v) {
            escapedParameters.push(v);
            return _this2.createParameter(key, escapedParameters.length - 1);
          }).join(", ");
        }
        if (typeof value === "function") {
          return value();
        } else if (typeof value === "number") {
          return String(value);
        }
        // Sqlite does not have a boolean data type so we have to transform
        // it to 1 or 0
        if (typeof value === "boolean") {
          escapedParameters.push(+value);
          return _this2.createParameter(key, escapedParameters.length - 1);
        }
        if (value instanceof Date) {
          escapedParameters.push(DateUtils.mixedDateToUtcDatetimeString(value));
          return _this2.createParameter(key, escapedParameters.length - 1);
        }
        escapedParameters.push(value);
        return _this2.createParameter(key, escapedParameters.length - 1);
      }); // todo: make replace only in value statements, otherwise problems
      return [sql, escapedParameters];
    }
    /**
     * Escapes a column name.
     */
  }, {
    key: "escape",
    value: function escape(columnName) {
      return '"' + columnName + '"';
    }
    /**
     * Build full table name with database name, schema name and table name.
     * E.g. myDB.mySchema.myTable
     *
     * Returns only simple table name because all inherited drivers does not supports schema and database.
     */
  }, {
    key: "buildTableName",
    value: function buildTableName(tableName, schema, database) {
      return tableName;
    }
    /**
     * Parse a target table name or other types and return a normalized table definition.
     */
  }, {
    key: "parseTableName",
    value: function parseTableName(target) {
      var _a;
      var driverDatabase = this.database;
      var driverSchema = undefined;
      if (InstanceChecker.isTable(target) || InstanceChecker.isView(target)) {
        var parsed = this.parseTableName(target.schema ? "\"".concat(target.schema, "\".\"").concat(target.name, "\"") : target.name);
        return {
          database: target.database || parsed.database || driverDatabase,
          schema: target.schema || parsed.schema || driverSchema,
          tableName: parsed.tableName
        };
      }
      if (InstanceChecker.isTableForeignKey(target)) {
        var _parsed = this.parseTableName(target.referencedTableName);
        return {
          database: target.referencedDatabase || _parsed.database || driverDatabase,
          schema: target.referencedSchema || _parsed.schema || driverSchema,
          tableName: _parsed.tableName
        };
      }
      if (InstanceChecker.isEntityMetadata(target)) {
        // EntityMetadata tableName is never a path
        return {
          database: target.database || driverDatabase,
          schema: target.schema || driverSchema,
          tableName: target.tableName
        };
      }
      var parts = target.split(".");
      if (parts.length === 3) {
        return {
          database: parts[0] || driverDatabase,
          schema: parts[1] || driverSchema,
          tableName: parts[2]
        };
      } else if (parts.length === 2) {
        var database = (_a = this.getAttachedDatabasePathRelativeByHandle(parts[0])) !== null && _a !== void 0 ? _a : driverDatabase;
        return {
          database: database,
          schema: parts[0],
          tableName: parts[1]
        };
      } else {
        return {
          database: driverDatabase,
          schema: driverSchema,
          tableName: target
        };
      }
    }
    /**
     * Creates a database type from a given column metadata.
     */
  }, {
    key: "normalizeType",
    value: function normalizeType(column) {
      if (column.type === Number || column.type === "int") {
        return "integer";
      } else if (column.type === String) {
        return "varchar";
      } else if (column.type === Date) {
        return "datetime";
      } else if (column.type === Boolean) {
        return "boolean";
      } else if (column.type === "uuid") {
        return "varchar";
      } else if (column.type === "simple-array") {
        return "text";
      } else if (column.type === "simple-json") {
        return "text";
      } else if (column.type === "simple-enum") {
        return "varchar";
      } else {
        return column.type || "";
      }
    }
    /**
     * Normalizes "default" value of the column.
     */
  }, {
    key: "normalizeDefault",
    value: function normalizeDefault(columnMetadata) {
      var defaultValue = columnMetadata.default;
      if (typeof defaultValue === "number") {
        return "" + defaultValue;
      }
      if (typeof defaultValue === "boolean") {
        return defaultValue ? "1" : "0";
      }
      if (typeof defaultValue === "function") {
        return defaultValue();
      }
      if (typeof defaultValue === "string") {
        return "'".concat(defaultValue, "'");
      }
      if (defaultValue === null || defaultValue === undefined) {
        return undefined;
      }
      return "".concat(defaultValue);
    }
    /**
     * Normalizes "isUnique" value of the column.
     */
  }, {
    key: "normalizeIsUnique",
    value: function normalizeIsUnique(column) {
      return column.entityMetadata.uniques.some(function (uq) {
        return uq.columns.length === 1 && uq.columns[0] === column;
      });
    }
    /**
     * Calculates column length taking into account the default length values.
     */
  }, {
    key: "getColumnLength",
    value: function getColumnLength(column) {
      return column.length ? column.length.toString() : "";
    }
    /**
     * Normalizes "default" value of the column.
     */
  }, {
    key: "createFullType",
    value: function createFullType(column) {
      var type = column.type;
      if (column.enum) {
        return "varchar";
      }
      if (column.length) {
        type += "(" + column.length + ")";
      } else if (column.precision !== null && column.precision !== undefined && column.scale !== null && column.scale !== undefined) {
        type += "(" + column.precision + "," + column.scale + ")";
      } else if (column.precision !== null && column.precision !== undefined) {
        type += "(" + column.precision + ")";
      }
      if (column.isArray) type += " array";
      return type;
    }
    /**
     * Obtains a new database connection to a master server.
     * Used for replication.
     * If replication is not setup then returns default connection's database connection.
     */
  }, {
    key: "obtainMasterConnection",
    value: function obtainMasterConnection() {
      return Promise.resolve();
    }
    /**
     * Obtains a new database connection to a slave server.
     * Used for replication.
     * If replication is not setup then returns master (default) connection's database connection.
     */
  }, {
    key: "obtainSlaveConnection",
    value: function obtainSlaveConnection() {
      return Promise.resolve();
    }
    /**
     * Creates generated map of values generated or returned by database after INSERT query.
     */
  }, {
    key: "createGeneratedMap",
    value: function createGeneratedMap(metadata, insertResult, entityIndex, entityNum) {
      var generatedMap = metadata.generatedColumns.reduce(function (map, generatedColumn) {
        var value;
        if (generatedColumn.generationStrategy === "increment" && insertResult) {
          // NOTE: When INSERT statement is successfully completed, the last inserted row ID is returned.
          // see also: SqliteQueryRunner.query()
          value = insertResult - entityNum + entityIndex + 1;
          // } else if (generatedColumn.generationStrategy === "uuid") {
          //     value = insertValue[generatedColumn.databaseName];
        }

        if (!value) return map;
        return OrmUtils.mergeDeep(map, generatedColumn.createValueMap(value));
      }, {});
      return Object.keys(generatedMap).length > 0 ? generatedMap : undefined;
    }
    /**
     * Differentiate columns of this table and columns from the given column metadatas columns
     * and returns only changed.
     */
  }, {
    key: "findChangedColumns",
    value: function findChangedColumns(tableColumns, columnMetadatas) {
      var _this3 = this;
      return columnMetadatas.filter(function (columnMetadata) {
        var tableColumn = tableColumns.find(function (c) {
          return c.name === columnMetadata.databaseName;
        });
        if (!tableColumn) return false; // we don't need new columns, we only need exist and changed
        var isColumnChanged = tableColumn.name !== columnMetadata.databaseName || tableColumn.type !== _this3.normalizeType(columnMetadata) || tableColumn.length !== columnMetadata.length || tableColumn.precision !== columnMetadata.precision || tableColumn.scale !== columnMetadata.scale || _this3.normalizeDefault(columnMetadata) !== tableColumn.default || tableColumn.isPrimary !== columnMetadata.isPrimary || tableColumn.isNullable !== columnMetadata.isNullable || tableColumn.generatedType !== columnMetadata.generatedType || tableColumn.asExpression !== columnMetadata.asExpression || tableColumn.isUnique !== _this3.normalizeIsUnique(columnMetadata) || columnMetadata.generationStrategy !== "uuid" && tableColumn.isGenerated !== columnMetadata.isGenerated;
        // DEBUG SECTION
        // if (isColumnChanged) {
        //     console.log("table:", columnMetadata.entityMetadata.tableName)
        //     console.log(
        //         "name:",
        //         tableColumn.name,
        //         columnMetadata.databaseName,
        //     )
        //     console.log(
        //         "type:",
        //         tableColumn.type,
        //         this.normalizeType(columnMetadata),
        //     )
        //     console.log(
        //         "length:",
        //         tableColumn.length,
        //         columnMetadata.length,
        //     )
        //     console.log(
        //         "precision:",
        //         tableColumn.precision,
        //         columnMetadata.precision,
        //     )
        //     console.log("scale:", tableColumn.scale, columnMetadata.scale)
        //     console.log(
        //         "default:",
        //         this.normalizeDefault(columnMetadata),
        //         columnMetadata.default,
        //     )
        //     console.log(
        //         "isPrimary:",
        //         tableColumn.isPrimary,
        //         columnMetadata.isPrimary,
        //     )
        //     console.log(
        //         "isNullable:",
        //         tableColumn.isNullable,
        //         columnMetadata.isNullable,
        //     )
        //     console.log(
        //         "generatedType:",
        //         tableColumn.generatedType,
        //         columnMetadata.generatedType,
        //     )
        //     console.log(
        //         "asExpression:",
        //         tableColumn.asExpression,
        //         columnMetadata.asExpression,
        //     )
        //     console.log(
        //         "isUnique:",
        //         tableColumn.isUnique,
        //         this.normalizeIsUnique(columnMetadata),
        //     )
        //     console.log(
        //         "isGenerated:",
        //         tableColumn.isGenerated,
        //         columnMetadata.isGenerated,
        //     )
        // }
        return isColumnChanged;
      });
    }
    /**
     * Returns true if driver supports RETURNING / OUTPUT statement.
     */
  }, {
    key: "isReturningSqlSupported",
    value: function isReturningSqlSupported() {
      return false;
    }
    /**
     * Returns true if driver supports uuid values generation on its own.
     */
  }, {
    key: "isUUIDGenerationSupported",
    value: function isUUIDGenerationSupported() {
      return false;
    }
    /**
     * Returns true if driver supports fulltext indices.
     */
  }, {
    key: "isFullTextColumnTypeSupported",
    value: function isFullTextColumnTypeSupported() {
      return false;
    }
    /**
     * Creates an escaped parameter.
     */
  }, {
    key: "createParameter",
    value: function createParameter(parameterName, index) {
      // return "$" + (index + 1);
      return "?";
      // return "$" + parameterName;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Creates connection with the database.
     */
  }, {
    key: "createDatabaseConnection",
    value: function createDatabaseConnection() {
      throw new TypeORMError("Do not use AbstractSqlite directly, it has to be used with one of the sqlite drivers");
    }
    /**
     * If driver dependency is not given explicitly, then try to load it via "require".
     */
  }, {
    key: "loadDependencies",
    value: function loadDependencies() {
      // dependencies have to be loaded in the specific driver
    }
  }]);
  return AbstractSqliteDriver;
}();